import React from 'react';
import Modal from '../../../../../components/Modal';
import Table from '../../../../../components/table/Table';
import { columns } from './columns';
import './EventItemListModal.scss';

const EventItemListModal = (props) => {
  const { isOpen, closeModal, getEventItemList, data, getProductSubCategoryList } = props;
  const { list, pagination } = data.listData;

  return (
    <Modal
      title="기획전 상품"
      isOpen={isOpen}
      width={1500}
      height={600}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="event-item-list-modal">
        <Table
          className="event-item-list-table"
          emptyText="기획전 아이템 리스트가 없습니다."
          data={list}
          pagination={pagination}
          getList={getEventItemList}
          showPagination
          columns={(utils) =>
            columns({
              ...utils,
              pageNum: pagination.pageNum,
              pageSize: pagination.pageSize,
              getProductSubCategoryList,
            })
          }
        />
      </div>
    </Modal>
  );
};

export default EventItemListModal;
